module.exports = __webpack_public_path__ + "static/media/store_ownership.b4aa7d41.jpg";